<template>
  <div class="created-all" v-loading="isSaveOk">
    <div class="all-header">
      <!-- btn  -->
      <div class="all-btn">
        <!-- 返回按钮 -->
        <el-button class="return-btn" @click="returnBtn">
          <div class="bmw-text" >返回</div>
        </el-button>

        <!-- 保存按钮 -->
        <el-button class="save-btn"  @click="saveTask">
          <div class="bmw-text">保存</div>
        </el-button>

      </div>
    </div>
    <div class="all-main">
      <div class="header">
        <!-- <div class="line"></div>
        <div class="title">基本信息</div>
        <div class="remarks">*新建必须填写品牌与业务团队项</div> -->
      </div>

      <!--隔离线 -->
      <div class="block_42 flex-col"></div>

      <div class="content-all">
        <div class="content-h">
          <div class="content">
            <div class="h-title"><span class="text_13">*</span> 任务类型</div>
            <div class="h-text">
              <el-radio-group v-model="bizType" @change="taskTypeChange">
                <el-radio :label="1">微课</el-radio>
                <el-radio :label="2">资料</el-radio>
                <el-radio :label="4">慕课</el-radio>
                <el-radio :label="6">混合式学习</el-radio>
                <el-radio :label="7">直播</el-radio>
                <el-radio :label="5">调研</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="box_23 flex-col"></div>
        <div class="content-main">
          <el-row class="row-style" :gutter=20>
            <el-col :span="6">
              <div class="content">
                <div class="double">
                  <div class="h-title">
                    <span class="text_13">*</span><div style="margin-right:26px">任务 </div>
                  </div>
                  <div
                    class="btn"
                    v-if="isCourse"
                    style="margin-top: -12px"
                    @click="showSelect"
                  >
                  <em class="el-icon-plus"></em>
                    <div class="text">选择</div>
                  </div>
                  <div v-else class="btn-disabled" style="margin-top: -12px">
                    <div class="text-left-disabled">+</div>
                    <div class="text-disabled">选择</div>
                  </div>
                </div>

                <div class="h-text">
                  <!-- <el-select v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select> -->
                  <el-input
                    :disabled="isCourseSelect"
                    v-model="courseSelect"
                  ></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="content">
                <div class="h-title">
                  <span class="text_13">*</span> 任务名称
                </div>
                <div class="h-text">
                  <!-- <el-select v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select> -->
                  <el-input class="custom-input" v-model="nameTasks" type="text" maxlength="25" show-word-limit style="padding: 0 0 12px 0 ;"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="content">
                <div class="h-title">
                  <span class="text_13">*</span>调研链接
                </div>
                <div class="h-text">
                  <!-- <el-select v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select> -->
                  <el-input :disabled="isCourse"  v-model="bizUrl"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="content">
                <div class="h-title">
                  <span class="text_13">*</span>业务团队
                </div>
                <div class="h-text">
                  <el-cascader
                    :disabled="editStatus"
                    :options="teamTypeGroups"
                    :props="casPropsGroup"
                    :change-on-select="true"
                    overflow-y="scroll"
                    v-model="teamTypeGroupsResult"
                    clearable
                    style="width: 470px"
                    popper-class="pc-sel-area-cascader"
                  >
                  </el-cascader>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row class="row-style" :gutter=20>
            <el-col :span="6">
              <div class="content">
                <div class="h-title">
                  <span class="text_13">*</span>有效期限
                </div>
                <div class="h-text">
                  <el-date-picker
                    size="medium"
                    v-model="timeValPub"
                    type="daterange"
                    @change="onTimePub"
                    range-separator="-"
                    :disabledDate="true"
                    format="yyyy-MM-dd "
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </div>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="content">
                <div class="h-title">
                  <span class="text_13">*</span>发布通知方式
                </div>
                <div class="h-text">
                  <!-- <el-select v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select> -->
                  <el-radio-group v-model="optional">
                    <el-radio :label="10">站内信</el-radio>
                    <el-radio :label="20">短信</el-radio>
                    <el-radio :label="30">不通知</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="content">
                <div class="h-title">
                  <span class="text_13">*</span> 截止通知方式
                </div>
                <div class="h-text">
                  <el-radio-group v-model="isNotify">
                    <el-radio :label="1">通知</el-radio>
                    <el-radio :label="0">不通知</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="content">
                <div class="h-title"></div>
                <div class="h-text"></div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="box_23 flex-col"></div>
        <div class="three-box">
          <!-- <div class="one">
        <div class="title"></div>
        <div class="content"></div>
    </div> -->
          <div class="one">
            <div class="title-all">
              <div class="title"><span class="text_13">*</span>面向组群
                <el-tooltip class="item" effect="light" content="组群内用户每24小时更新一次，如组群用户有任何调整，将在24小时后生效。" placement="bottom">
                  <div class="img-style"><img src="@/assets/img/task/taskquestion.png" alt="" /></div>
                </el-tooltip>
              </div>
              <div class="btn" @click="openSelectGroup">
                <em class="el-icon-plus"></em>
                <div class="text">选择</div>
              </div>
            </div>

            <div class="content">
              <div class="content-group" :style="{ 'max-height': 160 + 'px' }">
                <div
                  v-for="(item, index) in groupSelectList"
                  :key="index"
                  style="display: inline-block"
                >
                  <el-tag
                    >{{ item.groupName }}
                    <em class="el-icon-close" @click="delgroup(index)"></em>
                  </el-tag>
                </div>
              </div>
            </div>
          </div>

          <div class="one">
            <div class="title-all">
              <div class="title">
                <span class="text_13" :class="this.isNotify==0  ?  'white-star':'text_13'">*</span> 经销商岗位设置 – 用以员工任务管理
                <el-tooltip class="item" effect="light" content="该处岗位设置后，对应岗位用户可查看员工任务完成明细及员工任务截至前收到提醒邮件。" placement="bottom">
                  <div class="img-style"><img src="@/assets/img/task/taskquestion.png" alt="" /></div>
                </el-tooltip>
              </div>
              <div class="btn" @click="openPosition">
                <em class="el-icon-plus"></em>
                <div class="text">选择</div>
              </div>
            </div>

            <div class="content">
              <div
                :style="{ 'max-height': 160 + 'px' }"
                style="
                  background: 249, 250, 250;
                "
              >
                <div
                  v-for="(item, index) in positionSelectData"
                  :key="index"
                  style="display: inline-block"
                >
                  <el-tag
                    >{{ item.viewName
                    }}<em class="el-icon-close" @click="delPosition(index)"></em
                  ></el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="one">
            <div class="title"><span class="text_13">*</span>任务描述</div>

            <div class="content content2">
              <el-input
                maxlength="150"
                show-word-limit
                type="textarea"
                :rows="6"
                placeholder="请输入内容"
                v-model="taskdescribe"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  all popup  -->
    <el-dialog
      :visible.sync="resourceShowExam"
      width="1110px"
      custom-class="resource"
    >
      <div slot="title" class="header-title">
        <div class="line"></div>
        <div class="bmw-text-title">选择课程</div>
      </div>
      <!--隔离线 -->
      <div class="lines"></div>
      <div>
        <div class="tab" style="height: 397px !important">
          <!-- left  -->
          <div class="tab-left-exam">
            <div
              class="tab-left-name-course"
              :class="{ courseStyle: isCourseActive }"
              @click="courseEvent"
            >
              <div class="text" style="margin-top: 21px">微课</div>
            </div>
            <div
              class="tab-left-name-means"
              :class="{ meansStyle: isMeansActive }"
              @click="meansEvent"
            >
              <div class="text">资料</div>
            </div>
            <div
              class="tab-left-name-mooc"
              :class="{ moocStyle: isMoocActive }"
              @click="moocEvent"
            >
              <div class="text">慕课</div>
            </div>
            <div
              class="tab-left-name-mix"
              :class="{ mixStyle: isMixActive }"
              @click="mixEvent"
            >
              <div class="text">混合式学习</div>
            </div>
            <div
              class="tab-left-name-broadcast"
              :class="{ broadcastStyle: isBroadcastActive }"
              @click="broadcastEvent"
            >
              <div class="text">直播</div>
            </div>
          </div>

          <!-- right -->
          <!-- course -->
          <div v-show="isCourseActive"  class="tab-right-exam">
            <div class="resource-search">
              <el-row class="row-style">
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>课程名称</div>
                    <el-input v-model="form.courseName" placeholder=""></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>创建人</div>
                    <!-- <el-input
                      v-model="form.courseCreate"
                      placeholder=""
                    ></el-input> -->

                    <el-select v-model="form.courseCreate"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         placeholder=""
                         >
                <el-option v-for="(item,index) in resultCreateCourse"
                           :key="index"
                           :label="item.value"
                           :value="item.value">
                </el-option>
              </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>业务团队</div>
                    <el-select :clearable="true" v-model="form.courseTeam" placeholder="请选择">
                      <el-option v-for="item in team" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <el-button class="btns" @click="getCourseDataSelect()"
                    >查找</el-button
                  >
                </el-col>
              </el-row>
            </div>
            <el-table
            v-loading="isCourseShowLoading"
              height="316"
              :data="courseData"
              class="table-style"
              @current-change="handleSelectionChangeResourceCourse"
              :row-style="pointerStyle"
              tooltip-effect="light"
            >
              <el-table-column min-width="3%">
                <template slot-scope="scope">
                  <div>
                    <el-radio
                      v-model="radioCourse"
                      :label="scope.row.courseId"
                      >{{
                    }}</el-radio>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="课程编号"
                prop="courseCode"
                show-overflow-tooltip
                align="center"
                min-width="15%"
              >
              </el-table-column>
              <el-table-column
                label="课程名称"
                prop="courseName"
                min-width="15%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.creatDate) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="发布时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.pubDate) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="业务团队"
                min-width="8%"
                prop="teamTypeDesc"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建人"
                min-width="12%"
                prop="creatBy"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="pageCourse"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limitCourse"
              :total="totalCourse"
              layout="prev,pager,next"
              @size-change="pageSizeChangeHandleCourse"
              @current-change="pageCurrentChangeHandleCourse"
            >
            </el-pagination>
          </div>
          <!-- means -->
          <div v-show="isMeansActive"  class="tab-right-exam">
            <div class="resource-search">
              <el-row class="row-style">
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>资料名称</div>
                    <el-input v-model="form.docName" placeholder=""></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>创建人</div>
                    <el-select v-model="form.docCreatBy"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         placeholder=""
                         >
                <el-option v-for="(item,index) in resultCreateDoc"
                           :key="index"
                           :label="item.value"
                           :value="item.value">
                </el-option>
              </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>业务团队</div>
                    <el-select :clearable="true" v-model="form.docTeam" placeholder="请选择">
                      <el-option v-for="item in team" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <el-button class="btns" @click="getDocumentSelect">查找</el-button>
                </el-col>
              </el-row>
            </div>
            <el-table
              class="table-style"
              v-loading="isMeansShowLoading"
              height="316"
              :data="documentData"
              @current-change="handleSelectionChangeMeans"
              :row-style="pointerStyle"
              tooltip-effect="light"
            >
              <el-table-column min-width="3%">
                <template slot-scope="scope">
                  <div>
                    <el-radio
                      v-model="radioMeans"
                      :label="scope.row.documentId"
                      >{{
                    }}</el-radio>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="资料编号"
                show-overflow-tooltip
                prop="docCode"
                align="center"
                min-width="15%"
              >
              </el-table-column>
              <el-table-column
                label="资料名称"
                prop="docName"
                min-width="15%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>{{ formatDate(scope.row.creatDate*1) }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="发布时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.docPubDate * 1) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="业务团队"
                prop="teamTypeDesc"
                min-width="8%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建人"
                prop="creatBy"
                min-width="12%"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="pageMeans"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limitMeans"
              :total="totalMeans"
              layout="prev,pager,next"
              @size-change="pageSizeChangeHandleMeans"
              @current-change="pageCurrentChangeHandleMeans"
            >
            </el-pagination>
          </div>
          <!-- mooc -->
          <div v-show="isMoocActive"  class="tab-right-exam">
            <div class="resource-search">
              <el-row class="row-style">
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>慕课名称</div>
                    <el-input v-model="form.moocName" placeholder=""></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>创建人</div>
                    <el-select v-model="form.moocCreate"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         placeholder=""
                         >
                <el-option v-for="(item,index) in resultCreateMooc"
                           :key="index"
                           :label="item.value"
                           :value="item.value">
                </el-option>
              </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>业务团队</div>
                    <el-select :clearable="true" v-model="form.moocTeam" placeholder="请选择">
                      <el-option v-for="item in team" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <el-button class="btns" @click="getMoocSelect">查找</el-button>
                </el-col>
              </el-row>
            </div>
            <el-table
              class="table-style"
              v-loading="isMoocShowLoading"
              height="316"
              :data="moocData"
              @current-change="handleSelectionChangeMooc"
              :row-style="pointerStyle"
              tooltip-effect="light"
            >
              <el-table-column min-width="3%">
                <template slot-scope="scope">
                  <div>
                    <el-radio
                      v-model="radioMooc"
                      :label="scope.row.courseId"
                      >{{
                    }}</el-radio>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="慕课编号"
                prop="courseCode"
                show-overflow-tooltip
                align="center"
                min-width="15%"
              >
                <!-- <template slot-scope="scope">
                    <div>
                      <el-radio v-model="radio" :label="scope.row.examId">{{
                      ''
                      }}</el-radio>

                    </div>
                  </template> -->
              </el-table-column>
              <el-table-column
                label="慕课名称"
                prop="courseName"
                min-width="15%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.creatDate * 1) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="发布时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.pubDate * 1) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="业务团队"
                prop="teamTypeDesc"
                min-width="8%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建人"
                prop="creatBy"
                min-width="12%"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="pageMooc"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limitMooc"
              :total="totalMooc"
              layout="prev,pager,next"
              @size-change="pageSizeChangeHandleMooc"
              @current-change="pageCurrentChangeHandleMooc"
            >
            </el-pagination>
          </div>
          <!-- mix -->
          <div v-show="isMixActive"   class="tab-right-exam">
            <div class="resource-search">
              <el-row class="row-style">
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>混合式学习</div>
                    <el-input v-model="form.mixName"></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>创建人</div>
                    <el-select v-model="form.mixCreate"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         placeholder=""
                         >
                <el-option v-for="(item,index) in resultCreateMix"
                           :key="index"
                           :label="item.value"
                           :value="item.value">
                </el-option>
              </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>业务团队</div>
                    <el-select :clearable="true" v-model="form.mixTeam" placeholder="请选择">
                      <el-option v-for="item in team" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <el-button class="btns" @click="getMixedSelect">查找</el-button>
                </el-col>
              </el-row>
            </div>
            <el-table
            v-loading="isMixedShowLoading"
              class="table-style"
              height="316"
              :data="mixedData"
              @current-change="handleSelectionChangeResourceMixed"
              :row-style="pointerStyle"
              tooltip-effect="light"
            >
              <el-table-column min-width="3%">
                <template slot-scope="scope">
                  <div>
                    <el-radio
                      v-model="radioMixed"
                      :label="scope.row.courseId"
                      >{{
                    }}</el-radio>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="混合式学习编号"
                prop="courseCode"
                show-overflow-tooltip
                align="center"
                min-width="15%"
              >
              </el-table-column>
              <el-table-column
                label="混合式学习名称"
                prop="courseName"
                min-width="15%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.creatDate * 1) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="发布时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.pubDate * 1) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="业务团队"
                prop="teamTypeDesc"
                min-width="8%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建人"
                prop="creatBy"
                min-width="12%"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="pageMixed"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limitMixed"
              :total="totalMixed"
              layout="prev,pager,next"
              @size-change="pageSizeChangeHandleMixed"
              @current-change="pageCurrentChangeHandleMixed"
            >
            </el-pagination>
          </div>
          <!-- broadcast -->
          <div v-show="isBroadcastActive"    class="tab-right-exam">
            <div class="resource-search">
              <el-row class="row-style">
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>直播名称</div>
                    <el-input
                      v-model="form.broadcastName"
                      placeholder=""
                    ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>创建人</div>
                    <!-- <el-input
                      placeholder=""
                      v-model="form.broadCreateName"
                    ></el-input> -->
                    <el-select v-model="form.broadCreateName"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         placeholder=""
                         >
                <el-option v-for="(item,index) in resultCreateBroadcast"
                           :key="index"
                           :label="item.value"
                           :value="item.value">
                </el-option>
              </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="nameCreatBy">
                    <div>业务团队</div>
                    <el-select :clearable="true" v-model="form.broadcastTeam" placeholder="请选择">
                      <el-option v-for="item in team" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <el-button class="btns" @click="getBroadcastSelect">查找</el-button>
                </el-col>
              </el-row>
            </div>
            <el-table
            v-loading="isBroadcastShowLoading"
              height="316"
              :data="broadcastData"
              class="table-style"
              @current-change="handleSelectionChangeResourceBroadcast"
              :row-style="pointerStyle"
              tooltip-effect="light"
            >
              <el-table-column min-width="3%">
                <template slot-scope="scope">
                  <div>
                    <el-radio
                      v-model="radioBroadcast"
                      :label="scope.row.broadcastId"
                      >{{
                    }}</el-radio>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="直播编号"
                prop="broadcastCode"
                show-overflow-tooltip
                align="center"
                min-width="15%"
              >
              </el-table-column>
              <el-table-column
                label="直播名称"
                prop="broadcastName"
                min-width="15%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.createAt * 1) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="发布时间"
                min-width="15%"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    {{ formatDate(scope.row.startTime * 1) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="业务团队"
                prop="teamTypeDesc"
                min-width="8%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建人"
                prop="createName"
                min-width="12%"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="pageBroadcast"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limitBroadcast"
              :total="totalBroadcast"
              layout="prev,pager,next"
              @size-change="pageSizeChangeHandleBroadcast"
              @current-change="pageCurrentChangeHandleBroadcast"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="foot">
          <el-button @click="resourceShowExam = false">取 消</el-button>
          <el-button @click="allDefine" type="primary">确 定</el-button>
        </div>
      </span>
    </el-dialog>

    <!-- group pop -->

    <el-dialog
      :visible.sync="dialogFormVisibleselectGroup"
      custom-class="selectGroup"
      width="656px"
      height="631px"
    >
      <div slot="title" class="header-title">
        <div class="line"></div>
        <div class="bmw-text-title">选择组群</div>
      </div>
      <!--隔离线 -->
      <div class="lines"></div>
      <div class="select">
        <!-- select -->
        <el-row class="select-row" :gutter=30>
          <el-col :span="9">
            <div class="box">
              <div class="left">创建人</div>
              <div class="right">
                <el-input v-model="createNameGroup"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="9">
            <div class="box">
              <div class="left">组群名称</div>
              <div class="right">
                <el-input v-model="groupNameGroup"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <el-button class="btn-select" @click="selectGroup()">查找</el-button>
          </el-col>
        </el-row>
        <!--table -->
        <div v-loading="isGroupShowLoading">
          <el-table
            :data="listGroup"
            class="groupStyle"
            @selection-change="handleSelectionChangelistGroup"
            @row-click="toggleSelectionGroup"
            :row-style="pointerStyle"
            :row-key="getRowKeysListGroup"
            tooltip-effect="light"
            ref="rowlistGroup"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="creatBy"
              label="创建人"
              width="180"
              show-overflow-tooltip
            >
              <template> </template>
            </el-table-column>
            <el-table-column
              prop="groupName"
              label="组群名称"
              width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="groupIntro"
              label="组群描述"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          :current-page="pagelistGroup"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limitlistGroup"
          :total="totallistGroup"
          layout="prev,pager,next"
          @size-change="pageSizeChangeHandlelistGroup"
          @current-change="pageCurrentChangeHandlelistGroup"
        >
        </el-pagination>
        <!-- btn -->
        <div class="foot-btn">
          <div class="left"></div>
          <div class="right">
            <el-button class="right-cancel" @click="cancelGroup"
              >取消</el-button
            >
            <el-button class="right-define" @click="defineSelectGroup"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- position pop -->

    <el-dialog
      :visible.sync="dialogFormVisibleselectPosition"
      custom-class="selectGroup"
      width="656px"
      height="631px"
    >
      <div slot="title" class="header-title">
        <div class="line"></div>
        <div class="bmw-text-title">选择岗位</div>
      </div>
      <!--隔离线 -->
      <div class="lines"></div>
      <div class="select">
        <!-- select -->
        <el-row class="select-row" :gutter=30>
          <el-col :span="9">
            <div class="box">
              <div class="left">职位</div>
              <div class="right">
                <el-select
                  filterable
                  v-model="positionId"
                  :clearable="true"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in positionData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :span="9">
            <div class="box">
              <div class="left">分类</div>
              <div class="right">
                <el-select
                  filterable
                  v-model="taskClassifyId"
                  :clearable="true"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item,index) in taskClassifyData"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <el-button class="btn-select" @click="selectPosition">查找</el-button>
          </el-col>
        </el-row>
        <!--table -->
        <div v-loading="isPositionShowLoading">
          <el-table
            :data="listPosition"
            class="groupStyle"
            @selection-change="handleSelectionChangelistPosition"
            @row-click="toggleSelectionlistPosition"
            :row-style="pointerStyle"
            :row-key="getRowKeyslistPosition"
            tooltip-effect="light"
            ref="rowlistPosition"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="jobCode"
              label="职位代码"
              width="180"
              show-overflow-tooltip
            >
              <template> </template>
            </el-table-column>
            <el-table-column
              prop="positionName"
              label="职位"
              width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="classify"
              label="分类"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          :current-page="pagelistPosition"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limitlistPosition"
          :total="totallistPosition"
          layout="prev,pager,next"
          @size-change="pageSizeChangeHandlelistPosition"
          @current-change="pageCurrentChangeHandlelistPosition"
        >
        </el-pagination>
        <!-- btn -->
        <div class="foot-btn">
          <div class="left"></div>
          <div class="right">
            <el-button
              class="right-cancel"
              @click="dialogFormVisibleselectPosition = false"
              >取消</el-button
            >
            <el-button class="right-define" @click="defineSelectPosition"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- return dialog -->
    <returnComponent
      v-model="dialogVisibleReurn"
      :dialogVisibleReurn.sync="dialogVisibleReurn"

    ></returnComponent>

   <selectComponents
   v-model="dialogVisibleSelect"
   :dialogVisibleReurn.sync="dialogVisibleSelect"
   @define="defineSelect"
   @cancelSelect="cancelSelect"

   >

   </selectComponents>
    <!-- select dialog -->




  </div>

</template>

<script>
import {GlobalResTask} from './create.js'
export default {
 mixins:[GlobalResTask]
}
</script>

<style lang="scss" scoped>
//
.el-icon-plus{
  margin-top: 1px;
}
.img-style{
  font-size: 0px;
  cursor: pointer;
}
.el-tag {
  width: 95%;
  height: 24px;
  background: rgba(28, 105, 212, 0.08);
  border-radius: 5px !important;
  justify-content: center;
  margin: 5px;
  text-align: center;
  align-items: center;
  display: inline-flex;
  border: none;

   .el-icon-close {
    color: #c0c4cc !important;
  }
}

// pop group
.selectGroup {
  width: 618px;
  height: 631px !important;
  background: #ffffff;
  border-radius: 8px;
  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 0;
    height: 0px;
  }

  .lines {
    width: 615px !important;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
    margin: -26px 0px 10px 2px;
  }
  .select {
    .foot-btn {
      width: 100%;
      display: flex;

      .left {
        width: 70%;
      }

      .right {
        display: flex;

        .right-cancel {
          width: 81px;
          height: 32px;
          background: #ffffff;
          border-radius: 0px !important;
          border: 1px solid #dfe0e2;
        }

        .right-define {
          width: 76px;
          height: 32px;
          color: #ffff;
          background: #1c69d4;
          border-radius: 4px !important;
        }
      }
    }

    .select-row {
      margin-top: 20px;
    }

    .box {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      column-gap: 10px;

      .left {
        white-space: nowrap;
      }
    }

    .btn-select {
      width: 76px;
      height: 32px;
      background: #1c69d4;
      border-radius: 4px !important;
      color: #ffff;
      border: 1px solid rgba(28, 105, 212, 0.65);
    }
  }

  .groupStyle {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 369px;
    margin-top: 21px;
  }

  .header-title {
    display: flex;
    column-gap: 4px;
    align-items: center;
    text-align: center;

    .bmw-text-title {
      width: 64px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #252628;
      line-height: 22px;
    }
  }

  .line {
    width: 3px;
    height: 14px;
    background: #1c69d4;
  }

  .lines {
    width: 785px;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
    margin: -26px 0px 10px 2px;
  }
}

/deep/.el-radio-group {
  line-height: 1;
  vertical-align: middle;
  font-size: 0;
  display: flex;
  margin: 10px 0 0 0;
  .el-radio{
    margin-right: 16px;
  }
}

.el-range-input {
  background: #ffffff !important;
}

.el-date-editor {
  width: 100% !important;
}

.table-style {
  width: 99%;
  height: 316px !important;
  margin-top: 19px;
  margin-bottom: 8px;
  padding: 0 5px 0 14px;
}

// input radius
.el-input__inner {
  border-radius: 4px !important;
}

// 表格去除竖线

// lesson btn
.btn {
    width: 81px;
    height: 33px;
    background: #1c69d4;
    border-radius: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 6px;
    border: 1px solid #1c69d4;
    margin-top: -9px;
    color: #ffffff;
    cursor: pointer;

  .text-left {
    width: 13px;
    height: 1px;
     border: 1px solid #1C69D4;
  }

  .text {
    width: 28px;
    height: 20px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }
}

.btn-disabled {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 7px;
  width: 81px;
    height: 33px;
  border-radius: 4px;
  border: 1px solid #f2f4f5;
  .text-left-disabled {
    font-size: 24px;
    color: #f2f4f5;
  }
  .text-disabled {
    width: 28px;
    height: 20px;
    overflow-wrap: break-word;
    color: #f2f4f5;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }
}

.created-all {
  .text_13 {
    height: 20px;
    overflow-wrap: break-word;
    color: rgba(255, 65, 65, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }
  .white-star{
            height: 20px;
            overflow-wrap: break-word;
            color:#FFFFFF;
            font-size: 14px;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 20px;
          }

  // 头部
  .all-header {
    width: 100%;
    height: 48px;
    background: #ffffff;

    .all-btn {
      float: right;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 8px 24px 0 0;

      .save-btn {
        width: 76px;
        height: 32px;
        background: #1c69d4;
        border-radius: 4px !important;
        color: #ffffff;
      }

      .return-btn {
        width: 76px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px !important;
        border: 1px solid #dfe0e2;
        color: #5a5e66;
      }
    }
  }
  .all-main {
    width: 100%;
    height: 664px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 16px;
    .content-all {
      .box_23 {
        width: 97%;
        height: 1px;
        margin: 37px 0 0 24px;
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(60%, #ccc),
          color-stop(0, hsla(0, 0%, 100%, 0))
        );
        background-image: linear-gradient(
          90deg,
          #ccc 60%,
          hsla(0, 0%, 100%, 0) 0
        );
        background-position: bottom;
        background-size: 10px 1px;
        background-repeat: repeat-x;
      }

      .content {
        display: flex;
        flex-direction: column;
        row-gap: 9px;

        .h-title {
          white-space: nowrap;
          width: 68px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #252628ff;
          line-height: 20px;
          display: flex;
          column-gap: 5px;

          .text_13 {
            height: 20px;
            overflow-wrap: break-word;
            color: rgba(255, 65, 65, 1);
            font-size: 14px;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 20px;
          }

        }

        .h-text {
          width: 100%;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #252628;
          line-height: 20px;

          .el-input__inner {
            border-radius: 4px !important;
          }
        }
      }
      // h
      .content-h {
        padding: 16px 0 0 36px;
      }
      //   main
      .content-main {
        .row-style {
          padding: 24px 24px 12px 34px;

          .double {
            display: flex;
            justify-content: space-between;
          }
        }

        .main-h {
          display: flex;
          padding: 24px 0 0 36px;
          column-gap: 20%;
        }
      }

      // box
      .three-box {
        display: flex;
        column-gap: 24px;
        .title {
          width: 60px;
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #252628;
          line-height: 22px;
        }

        .content {
          overflow: auto;
          opacity: 1;
          height: 168px;
          display: table-cell;
          margin-top: 20px;
          border-radius: 4px;
          border-color: #eff0f1;
          border: 2px solid #eff0f1;
          background: #ffffff;
          padding-top: 5px;
          padding-left: 10px;
          .el-textarea {
            width: 101%;
            margin-left: -4px;
            height: 100%;
          }
          .el-textarea__inner {
            min-height: 48.996px;
            border: red;
            height: 162px;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #252628;
            resize: none;
            margin-top: -4px;
            border: none !important;
          }
        }

        .one {
          width: 30%;
          padding: 24px 0 0 36px;
          display: flex;
          flex-direction: column;
          .title {
            display: flex;
            column-gap: 5px;
          }
          .content-group {
            background: 249, 250, 250;
          }

          .title {
            white-space: nowrap;
          }

          .title-all {
            display: flex;
            justify-content: space-between;

            .title {
              display: flex;
              column-gap: 5px;
              width:71%;
              white-space: normal;
            }

            .btn {
              margin-left: 8px;
              width: 81px;
              height: 33px;
               background: #1c69d4;
              border-radius: 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              column-gap: 6px;
              border: 1px solid #1c69d4;
              margin-top: -9px;
              color:#ffffff;
              cursor: pointer;

              .text {
                  width: 28px;
                  height: 20px;
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
                  font-weight: 400;
                  color: #FFFFFF;
                  line-height: 20px;
              }
            }
          }
        }
      }
    }

    // header
    .header {
      display: flex;
      align-items: center;
      text-align: center;
      column-gap: 4px;
      padding: 24px 0 0 24px;

      .line {
        width: 3px;
        height: 14px;
        background: #1c69d4;
      }

      .title {
        width: 64px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #252628;
        line-height: 22px;
      }

      .remarks {
        width: 175px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #5a5c60;
        line-height: 18px;
        margin-left: 12px;
      }
    }

    .block_42 {
      width: 97%;
      height: 1px;
      background: #eeeff0ff -1px 0px no-repeat;
      background-size: 98% 1px;
      margin: 13px 0 12px 24px;
    }
  }
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollt-corner {
    display: block;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border-right-color: transparent;
    border-left-color: transparent;
    background: #ffff(0, 0, 0, 0.1);
  }
}

// pagination  style

</style>
<style>
.el-input {
  border-radius: 4px !important;
}

.el-tooltip__popper {
  border: none !important;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08);
}

.el-range-input {
  font-size: 13px !important;
}

/* 表单头部颜色更改 */
.aui-wrapper .el-table th {
  background: #fafbff !important;
  border-right: 1px #dcdee3 solid;
}
</style>
<style lang="scss">
.pc-sel-area-cascader {
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollt-corner {
    display: block;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border-right-color: transparent;
    border-left-color: transparent;
    background: #ffff(0, 0, 0, 0.1);
  }
}

.el-cascader-menu {
  display: inline-block;
  vertical-align: top;
  height: 100% !important;
  overflow: auto;
  border-right: solid 1px #e4e7ed;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 6px 0;
}
.created-all {
  .el-table {
    tr th,
    tr td {
      border-right: none !important;
    }
  }
  .content2 {
    .el-textarea__inner {
      margin-top: -4px !important;
    }
  }
  .el-pagination {
    display: flex;
    float: right;
    padding: 4px 0px 21px 0;
    margin-right: 15px;
    .el-pagination__jump {
      margin-left: 1px !important;
    }
    .el-pager {
      display: flex;
      flex-direction: row;
      column-gap: 9px;
      .number.active {
        color: #ffffff !important;
        background: #1c69d4ff !important;
        border-radius: 2px !important;
      }
      .number {
        width: 30px;
        height: 29px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #dfe0e2;
      }
    }
    .btn-prev {
      height: 29px;
      background: #ffffff;
      border-radius: 1px;
      border: 1px solid #dfe0e2;
      margin-right: 10px;
      margin-left: 7px;
    }
    .btn-next {
      height: 29px;
      background: #ffffff;
      border-radius: 1px;
      border: 1px solid #dfe0e2;
      margin-right: 4px;
      margin-left: 10px;
    }
  }
  .el-textarea__inner {
    border: 1px solid transparent;
    resize: none !important;
  }
  .el-dialog__footer {
    padding: 0 !important;
    text-align: right !important;
  }
  // pop group
  .selectGroup {
    width: 618px;
    height: 631px !important;
    background: #ffffff;
    border-radius: 8px !important;
    .el-table::before {
      left: 0;
      bottom: 0;
      width: 100%;
      z-index: 0;
      height: 0px;
    }

    .lines {
      width: 615px !important;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin: -26px 0px 10px 2px;
    }
    .select {
      .foot-btn {
        width: 100%;
        display: flex;

        .left {
          width: 70%;
        }

        .right {
          display: flex;

          .right-cancel {
            width: 81px;
            height: 32px;
            background: #ffffff;
            border-radius: 4px !important;
            border: 1px solid #dfe0e2;
          }

          .right-define {
            width: 76px;
            height: 32px;
            color: #ffff;
            background: #1c69d4;
            border-radius: 4px !important;
          }
        }
      }

      .select-row {
        margin-top: 20px;
      }

      .box {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        column-gap: 10px;

        .left {
          white-space: nowrap;
        }
      }

      .btn-select {
        width: 76px;
        height: 32px;
        background: #1c69d4;
        border-radius: 4px !important;
        color: #ffff;
        border: 1px solid rgba(28, 105, 212, 0.65);
      }
    }

    .groupStyle {
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      height: 369px;
      margin-top: 21px;
    }

    .header-title {
      display: flex;
      column-gap: 4px;
      align-items: center;
      text-align: center;

      .bmw-text-title {
        width: 64px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #252628;
        line-height: 22px;
      }
    }

    .line {
      width: 3px;
      height: 14px;
      background: #1c69d4;
    }

    .lines {
      width: 785px;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin: -26px 0px 10px 2px;
    }
  }
  .resource {
    .el-input,
    .el-input__inner {
      border-radius: 4px !important;
    }
    .el-input__inner {
      border-radius: 4px !important;
    }
    .header-title {
      display: flex;
      column-gap: 4px;
      align-items: center;
      text-align: center;

      .bmw-text-title {
        width: 64px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #252628;
        line-height: 22px;
      }
    }
    .line {
      width: 3px;
      height: 14px;
      background: #1c69d4;
    }
    .lines {
      width: 1066px;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin: -26px 0px 10px 2px;
    }
    width: 1110px;
    height: 600px;
    background: #ffffff;
    border-radius: 8px !important;
    .tab {
      width: 1063px;
      height: 396px;
      margin: 0 auto;
      border-radius: 4px !important;
      padding-top:9px;
      display: flex;

      .tab-left-exam {
        width: 116px;
        height: 396px;
        border: 1px solid #dfe0e2;
        border-right: none;
        cursor: pointer;

        .text {
          padding-top: 10px;
          margin: 0px 0 0 23px;
          width: 28px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #252628;
          line-height: 20px;
          white-space: nowrap;
        }

        .tab-left-name-course {
          width: 115px;
          height: 40px;
          background: #ffff;
          color: #252628;
        }

        .tab-left-name-course:hover {
          background: #edf3fc;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }

        .tab-left-name-course:hover {
          background: #edf3fc;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }

        .tab-left-name-means:hover {
          background: #edf3fc;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }

        .tab-left-name-mooc:hover {
          background: #edf3fc;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }

        .tab-left-name-mix:hover {
          background: #edf3fc;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }
        .courseStyle {
          background: #edf3fc !important;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }
        .meansStyle {
          background: #edf3fc !important;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }
        .moocStyle {
          background: #edf3fc !important;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }
        .mixStyle {
          background: #edf3fc !important;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }
        .broadcastStyle {
          background: #edf3fc !important;
          color: #1c69d4;
          border-right: 4px solid #1c69d4;
        }
        .tab-left-name-means {
          width: 115px;
          height: 40px;
          background: #ffff;
          color: #252628;
        }
        .tab-left-name-mooc {
          width: 115px;
          height: 40px;
          background: #ffff;
          color: #252628;
        }
        .tab-left-name-mix {
          width: 115px;
          height: 40px;
          background: #ffff;
          color: #252628;
        }
        .tab-left-name-broadcast {
          width: 115px;
          height: 40px;
          background: #ffff;
          color: #252628;
        }
      }
      .tab-right-exam {
        width: 947px;
        height: 396px;
        border: 1px solid #dfe0e2;
        .nameCreatBy {
          display: flex;
          white-space: nowrap;
          justify-content: center;
          align-items: center;
          text-align: center;
          column-gap: 5px;
          margin: 26px 0 0 24px;
          .el-input__inner {
            border-radius: 4px !important;
          }
        }
        .btns {
          margin: 27px 0 0 -75px;
          width: 76px;
          height: 32px;
          background: #1c69d4;
          color: #ffff;
          border-radius: 4px !important;
        }
      }
    }
    .foot {
      margin: 33px 24px 0px 0;
      padding: 19px 0 24px 0;
      .el-button {
        border-radius: 4px !important;
      }
    }
    .section_127 {
      width: 10px;
      height: 10px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng51865692598bb2cc80457ecfef61f2db16c948884720c705b25f6f16837a8ddf)
        100% no-repeat;
      background-size: 100% 100%;
      margin-top: 1px;
    }
  }
}
</style>
